import { render, staticRenderFns } from "./UpdateCommissionDropdown.vue?vue&type=template&id=c25e264e&scoped=true"
import script from "./UpdateCommissionDropdown.vue?vue&type=script&lang=ts"
export * from "./UpdateCommissionDropdown.vue?vue&type=script&lang=ts"
import style0 from "./UpdateCommissionDropdown.vue?vue&type=style&index=0&id=c25e264e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25e264e",
  null
  
)

export default component.exports